import { getApiKey } from "../../utils/apiKey";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import useSimpleReactValidator from "../../Hooks/useSimpleReactValidator";
import { apiCall_domain } from "../api";
import Header from "../header";
import PulseLoader from "react-spinners/PulseLoader";
const Changeename = (props) => {
  const [state, setState] = useState();
  const [loading, setLoading] = useState(true);
  const [validator, forceUpdate] = useSimpleReactValidator({
    className: "danger changeName",
    messages: { required: "این فیلد نباید خالی باشد" },
    autoForceUpdate: true,
  });
  const [submitLoading, setSubmitLoading] = useState(false);
  const headers = {
    Authorization: getApiKey(),
    "content-type": "application/json",
  };

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("splash"));
    setState(userInfo.customer_info);
    setLoading(false);
  }, []);
  const submit = () => {
    validator.showMessages();
    forceUpdate(true);

    if (validator.allValid()) {
      setSubmitLoading(true);
      const Data = {
        name: state.name,
        city_id: state.city.id,
      };
      axios
        .post(`${apiCall_domain}/customer/user`, Data, { headers: headers })
        .then((res) => {
          axios
            .get(`${apiCall_domain}/customer/splash`, { headers: headers })
            .then((res) => {
              setSubmitLoading(false);
              localStorage.setItem("splash", JSON.stringify(res.data));
              props.history.goBack();
            });
        });
    }
  };
  const handleNameChange = (e) => {
    setState({ ...state, name: e.target.value });
  };
  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Header
            showSearchBar={true}
            isDarkTheme={true}
            backUrl="/profile"
            title="تغییر نام کاربری"
          />
          <div className="logoutChangeename">
            <div className="ChangeenameMain">
              <strong className="changeenameText">
                نام و نام خانوادگی خود را وارد کنید
              </strong>
              <input
                className="changeenameinput"
                type={"text"}
                name="name"
                value={state.name}
                placeholder="نام و نام خانوادگی"
                onChange={handleNameChange}
              />
              {validator.message("name", state.name, "required")}
            </div>
            <button onClick={submit} className="btn btn--confirmation">
              {submitLoading ? <PulseLoader color="#fff" size={10} /> : "تایید"}
            </button>
          </div>
        </>
      )}
    </>
  );
};
export default Changeename;
